import React, { FC, ReactNode } from "react";

import { Avatar } from "@/features/common/components/avatar/Avatar";
import TextPlaceholder from "@/features/placeholder/TextPlaceholder";
import { useUserBasicInfoQuery } from "@/generated/generated-hooks";

export const NFTPostContentMenuItem: FC<{
  loading?: boolean;
  imageAlt?: string;
  walletAccount: string;
  upperContent: ReactNode | string;
  lowerContent: ReactNode | string;
  withBy?: boolean;
  withBorder?: boolean;
}> = (props) => {
  const {
    loading = false,
    imageAlt,
    walletAccount,
    upperContent,
    withBy = false,
    withBorder = true,
    lowerContent,
  } = props;

  // TODO: selectively get user attributes
  const {
    data: matchedUser,
    loading: fetchLoading,
    error: fetchError,
  } = useUserBasicInfoQuery({
    variables: {
      walletAccount,
    },
    context: { batch: true },
  });

  // if loading & matching user with walletaccount
  if (loading || fetchLoading || fetchError) {
    return (
      <div
        className={`flex items-center ${
          withBorder && "p-4 bg-white border border-gray-200"
        } w-full space-x-4`}
      >
        <div className="h-16 w-16">
          <TextPlaceholder size="5xl" />
        </div>

        <div className="w-full">
          <div className="w-2/5">
            <TextPlaceholder />
          </div>
          <div className="mt-1">
            <div className="w-2/5">
              <TextPlaceholder />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex items-center ${
        withBorder && "p-4 bg-white border border-gray-200"
      } w-full space-x-3`}
    >
      <div className="flex-none">
        <Avatar
          avatar={{
            alt: imageAlt
              ? imageAlt
              : `The avatar of user ${
                  matchedUser?.user
                    ? matchedUser.user.displayName
                    : walletAccount
                }`,
            src: matchedUser?.user?.avatar?.url,
          }}
        />
      </div>

      <div className="flex-1 flex flex-col text-gray-900 overflow-hidden">
        <span className=" flex truncate min-w-0 whitespace-pre">
          {upperContent}
        </span>

        <div className="mt-1 flex truncate min-w-0 whitespace-pre">
          {lowerContent}
        </div>
      </div>
    </div>
  );
};
